'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UICardSection;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CardContext = require('../context/CardContext');

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var scrollableMixin = (0, _styledComponents.css)(['flex:1 1 auto;overflow:auto;&:last-child{margin-bottom:', ';}'], function (_ref) {
  var compact = _ref.compact;
  return compact ? '24px' : '40px';
});

var siblingPaddingMixin = (0, _styledComponents.css)(['+ .private-card__section,+ * .private-card__section{padding-top:0;}']);

var Section = _styledComponents2.default.div.withConfig({
  displayName: 'UICardSection__Section'
})(['padding:', ';border-radius:inherit;', ';'], function (_ref2) {
  var compact = _ref2.compact,
      flush = _ref2.flush,
      isHeader = _ref2.isHeader,
      scrollable = _ref2.scrollable;

  var paddingTop = compact ? '24px' : '40px';
  var paddingBottom = isHeader || scrollable ? '0' : paddingTop;
  var paddingX = flush ? '0' : paddingTop;
  return paddingTop + ' ' + paddingX + ' ' + paddingBottom;
}, function (_ref3) {
  var scrollable = _ref3.scrollable;
  return scrollable ? scrollableMixin : siblingPaddingMixin;
});

function UICardSection(_ref4) {
  var className = _ref4.className,
      rest = _objectWithoutProperties(_ref4, ['className']);

  var _useContext = (0, _react.useContext)(_CardContext.CardContext),
      compact = _useContext.compact;

  return _react2.default.createElement(Section, _extends({}, rest, {
    className: (0, _classnames2.default)('private-card__section', 'has--vertical-spacing', className),
    compact: compact
  }));
}

UICardSection.defaultProps = {
  flush: false,
  isHeader: false,
  scrollable: false
};

UICardSection.propTypes = {
  children: _propTypes2.default.node,
  flush: _propTypes2.default.bool,
  isHeader: (0, _decorators.hidden)(_propTypes2.default.bool),
  scrollable: _propTypes2.default.bool
};

UICardSection.displayName = 'UICardSection';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/card/UICardSection.js
// module id = 126
// module chunks = 177